import(/* webpackMode: "eager" */ "/vercel/path0/src/app/motorized-blinds/page.tsx");
